import script from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=ts"

import "./LoadMoreButton.vue?vue&type=style&index=0&id=7df9195e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df9195e"]])

export default __exports__